import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import config from "../../config/config.js";
import { useAuth } from "../login/AuthContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { AddCircleOutline } from "@mui/icons-material";
import "../customers/customers.css";
import { Button } from "@mui/material";

export default function PdksLicenses() {
  const { token } = useAuth();
  const navigate = useNavigate();
  const headers = { Authorization: `Bearer ${token}` };
  const [rows, setRows] = useState([]);

  const load = useCallback(async () => {
    try {
      const l = await axios.get(`${config.baseURL}/pdks-lisanslar`, { headers });
      setRows(l.data || []);
    } catch {
      toast.error("PDKS lisansları yüklenemedi");
    }
  }, [token]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="cari-listesi-container">
      <div className="header">
        <h1>PDKS Lisansları</h1>
      </div>
      <p style={{ margin: "0 0 12px", color: "#64748b", fontSize: 13 }}>
        Lisans anahtarı sipariş onayında üretilir. Anahtarı kopyalayıp müşteri PDKS uygulamasında Lisans menüsüne yapıştırın.
      </p>
      <div className="search-bar">
        <Button
          variant="contained"
          startIcon={<AddCircleOutline />}
          onClick={() => navigate("/pdks/siparis")}
        >
          Sipariş / Lisans Oluştur
        </Button>
      </div>
      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Key</th>
              <th>Müşteri</th>
              <th>Paket</th>
              <th>Edition</th>
              <th>Personel</th>
              <th>Kullanıcı</th>
              <th>Bitiş</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.Id}>
                <td
                  style={{ cursor: "pointer" }}
                  title="Kopyala"
                  onClick={() => {
                    navigator.clipboard.writeText(r.LisansKey);
                    toast.success("Anahtar kopyalandı");
                  }}
                >
                  {r.LisansKey}
                </td>
                <td>{r.MusteriUnvan || r.MusteriNo || r.MusteriId}</td>
                <td>{r.PaketAdi || "—"}</td>
                <td>{r.Edition}</td>
                <td>{r.MaxPersonnel}</td>
                <td>{r.MaxKullaniciSayisi}</td>
                <td>{r.BitisTarih || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
